module.exports = __webpack_public_path__ + "img/cloudPayFail.b85634e8.png";